import { motion } from "framer-motion";
import { HeartHandshake, PhoneCall, TrendingUp } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const QUOTE = "Le persone sono gestite da altre persone, non da un algoritmo.";

const POINTS = [
  { icon: HeartHandshake, label: "Rapporto umano al centro", testid: "manifesto-point-1" },
  { icon: PhoneCall, label: "Contatto diretto col team", testid: "manifesto-point-2" },
  { icon: TrendingUp, label: "Crescita reale dei rider", testid: "manifesto-point-3" },
];

export const HumanManifestoSection = () => {
  const words = QUOTE.split(" ");
  return (
    <section id="valore" data-testid="manifesto-section" className="relative py-24 sm:py-36 px-5 sm:px-8 overflow-hidden">
      <div className="hero-glow w-[500px] h-[500px] bg-brand/12 top-1/3 -left-64" />
      <div className="relative max-w-5xl mx-auto">
        <SectionHeading eyebrow="03 — Il Nostro Valore" title="Perché siamo diversi" testid="manifesto-title" />

        <p
          data-testid="manifesto-quote"
          className="font-display font-black tracking-tight leading-[1.08] text-3xl sm:text-5xl lg:text-6xl text-white"
        >
          {words.map((w, i) => (
            <span key={i} className="inline-block overflow-hidden align-bottom mr-[0.28em] pb-1">
              <motion.span
                className={`inline-block ${
                  ["persone,", "algoritmo."].includes(w) ? "text-brand italic" : ""
                }`}
                initial={{ y: "110%" }}
                whileInView={{ y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              >
                {w}
              </motion.span>
            </span>
          ))}
        </p>

        <Reveal delay={0.2} className="mt-10 max-w-2xl">
          <p className="text-base sm:text-lg leading-relaxed text-muted2">
            A differenza delle tradizionali aziende di delivery, noi mettiamo al centro il rapporto umano e
            interpersonale. Ci teniamo davvero alla crescita dei nostri addetti alle consegne: da noi le persone
            sono gestite da altre persone, non da un algoritmo!
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-3 gap-4">
          {POINTS.map((p, i) => (
            <Reveal key={p.label} delay={0.1 + i * 0.1}>
              <div
                data-testid={p.testid}
                className="flex items-center gap-4 bg-card2/70 border border-brand/20 rounded-2xl px-5 py-4 hover:border-brand/60 hover:bg-cardhover transition-colors duration-300"
              >
                <p.icon className="w-5 h-5 text-brand shrink-0" />
                <span className="font-display font-bold text-sm sm:text-base text-white">{p.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
